<template>
  <section
    class="payment-section"
    data-private
  >
    <b-container>
      <b-row>
        <b-col cols="12">
          <div class="payment-card section-card">
            <b-row class="payment-form">
              <b-col cols="3">
                <div class="card-icon">
                  <font-awesome-icon
                    :icon="cardIconForm"
                    :style="{color: cardColorForm}"
                    size="6x"
                  />
                </div>
              </b-col>
              <b-col
                md="9"
                class="card-details"
              >
                <b-row>
                  <b-col
                    md="12"
                    class="card-name required"
                  >
                    <b-form-group
                      id="cardholder-name-group"
                      label="Cardholder Name"
                      label-for="cardholder-name"
                      class="required"
                      data-cy="cardholder-name"
                    >
                      <b-form-input
                        id="cardholder-name"
                        v-model="newCard.cardholderName"
                        v-validate="'required'"
                        :state="getErrorState('cardholder-name')"
                        placeholder="Cardholder Name as it appears on the Credit Card"
                        data-vv-as="cardholder name"
                        data-vv-scope="payment"
                        name="cardholder-name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    md="12"
                    class="card-number required"
                  >
                    <b-form-group
                      id="card-number-group"
                      label="Card Number"
                      label-for="card-number"
                      class="required"
                      data-cy="card-number"
                    >
                      <b-input-group>
                        <b-form-input
                          id="card-number"
                          v-model="newCard.cardNumber"
                          v-mask="cardMask"
                          v-validate="'required|credit_card'"
                          :state="getErrorState('card-number')"
                          placeholder="Credit Card Number"
                          data-vv-as="card number"
                          data-vv-scope="payment"
                          name="card-number"
                          type="text"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    md="8"
                    class="card-expiry required"
                    data-cy="card-expiry"
                  >
                    <b-form-group
                      id="expiry-date"
                      label="Expiry Date"
                      label-for="expiry-month"
                      class="required"
                    >
                      <b-row>
                        <b-col
                          md="4"
                          class="mr-md-0 pr-md-0"
                        >
                          <b-form-select
                            id="expiry-month"
                            ref="expiremonth"
                            v-model="expiryMonth"
                            v-validate="'required|expiry_date:expireyear'"
                            :state="getErrorState('expiry-month')"
                            :options="expmonths"
                            data-vv-as="expiry-month"
                            data-vv-scope="payment"
                            name="expiry-month"
                            class="pr-md-0 mr-md-0"
                          >
                            <template slot="first">
                              <option
                                value=""
                                disabled
                                hidden
                              >
                                Month
                              </option>
                            </template>
                          </b-form-select>
                        </b-col>
                        <b-col
                          md="5"
                          class="ml-md-2 pl-md-0"
                        >
                          <b-form-select
                            id="expiry-year"
                            ref="expireyear"
                            v-model="expiryYear"
                            v-validate="'required|expiry_date:expiremonth'"
                            :state="getErrorState('expiry-month')"
                            :options="expyears"
                            data-vv-as="expiry-year"
                            data-vv-scope="payment"
                            name="expiry-year"
                            class="ml-md-0"
                          >
                            <template slot="first">
                              <option
                                value=""
                                disabled
                                hidden
                              >
                                Year
                              </option>
                            </template>
                          </b-form-select>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                  <b-col
                    md="4"
                    class="card_ccv required"
                  >
                    <b-form-group
                      id="cvc-group"
                      label="CVC"
                      label-for="cvc"
                      class="required"
                      data-cy="card-cvv"
                    >
                      <b-form-input
                        id="cvc"
                        v-model="newCard.cvc"
                        v-validate="'required|min:3|max:4'"
                        :state="getErrorState('cvc')"
                        placeholder="CVC"
                        data-vv-as="cvc"
                        data-vv-scope="payment"
                        name="cvc"
                        maxlength="4"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                    v-if="showOverrideAmountInput"
                    md="4"
                    data-cy="payment-testing"
                  >
                    <integrapay-payment-testing v-model="override_amount" />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row
              v-if="showCardSave"
              class="card-save"
            >
              <b-form-checkbox
                id="store-card"
                v-model="newCard.cardSave"
                :value="true"
                :unchecked-value="false"
              >
                Save Card for future use
              </b-form-checkbox>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="auto"
                class="error-field"
              >
                {{ errorMessage() }}
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import PaymentTesting from './payment-testing.vue'

const ExpiryDateValidator = function(value, [otherValue]) {
  if (!['expireyear', 'expiremonth'].includes(otherValue)) {
    try {
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth() + 1
      let month = parseInt(value)
      let year = otherValue
      if (year <= 12) {
        return true
      }
      if (year > currentYear) {
        return true
      }
      else if (year < currentYear) {
        return false
      }
      else if (month >= currentMonth) {
        return true
      }
      else {
        return false
      }
    }
    catch (err) {
      return false
    }
  }
  return false
}

export default {

  name: 'credit-card-form',
  components: {
    'integrapay-payment-testing': PaymentTesting
  },
  props: {
    showCardSave: {
      type: Boolean,
      default: false
    },
    paymentTesting: {
      type: Boolean,
      required: false,
      default: false
    },
    showOverrideAmount: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: Object,
      default: () => ({
        cardholderName: '',
        cardNumber: '',
        expiryMonth: '',
        expiryYear: '',
        cvc: '',
        cardType: null,
        cardSave: false
      })
    }
  },
  data() {
    return {
      override_amount: '',
      cards: {
        mastercard: {
          mask: '#### #### #### ####',
          regex: /^(5[1-5])/,
          icon: ['fab', 'cc-mastercard'],
          color: '#ff9900',
          lengths: [16]
        },
        visa: {
          mask: '#### #### #### ####',
          regex: /^4/,
          icon: ['fab', 'cc-visa'],
          color: '#1a1f71',
          lengths: [16]
        },
        amex: {
          mask: '#### #### #### ###',
          regex: /^3(4|7)/,
          icon: ['fab', 'cc-amex'],
          color: '#002663',
          lengths: [15]
        },
        discover: {
          mask: '#### #### #### #### ###',
          regex: /^6(011|4|5)/,
          icon: ['fab', 'cc-discover'],
          color: '#ff6000',
          lengths: [16, 17, 18, 19]
        },
        jcb: {
          mask: '#### #### #### #### ###',
          regex: /^35((2[8-9])|([3-8][0-9]))/,
          icon: ['fab', 'cc-jcb'],
          color: '#44a936',
          lengths: [16, 17, 18, 19]
        },
        'diners-club': {
          mask: '#### #### #### #### ###',
          regex: /^3(6|8|9|0([0-5]|95))/,
          icon: ['fab', 'cc-diners-club'],
          color: '#0079be',
          lengths: [16, 17, 18, 19]
        }
      }
    }
  },
  computed: {
    showOverrideAmountInput: function() {
      return this.showOverrideAmount && this.paymentTesting
    },
    expiryMonth: {
      get: function() {
        return this.newCard.expiryMonth
      },
      set: function(value) {
        this.$set(this.newCard, 'expiryMonth', value)
      }
    },
    expiryYear: {
      get: function() {
        return this.newCard.expiryYear
      },
      set: function(value) {
        this.$set(this.newCard, 'expiryYear', value)
      }
    },
    newCard: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    expmonths() {
      return [
        { value: '01', text: 'Jan' },
        { value: '02', text: 'Feb' },
        { value: '03', text: 'Mar' },
        { value: '04', text: 'Apr' },
        { value: '05', text: 'May' },
        { value: '06', text: 'Jun' },
        { value: '07', text: 'Jul' },
        { value: '08', text: 'Aug' },
        { value: '09', text: 'Sept' },
        { value: '10', text: 'Oct' },
        { value: '11', text: 'Nov' },
        { value: '12', text: 'Dec' }
      ]
    },
    expyears() {
      let y = new Date().getFullYear()
      return [...Array(10).keys()].map(x => ({ value: y + x, text: y + x }))
    },
    cardIconForm() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].icon
      }
      return ['fas', 'credit-card']
    },
    cardColorForm() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].color
      }
      return '#495057'
    },
    cardIcon() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].icon
      }
      return ['fas', 'credit-card']
    },
    cardColor() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].color
      }
      return '#495057'
    },
    cardMask() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].mask
      }
      return '#### #### #### ####'
    },
    cardLengths() {
      if (this.newCard.cardType && this.cards[this.newCard.cardType]) {
        return this.cards[this.newCard.cardType].lengths
      }
      return [15, 16, 17, 18, 19]
    },
    cardholderName() {
      return this.newCard.cardholderName
    },
    visibleDigitStart() {
      if (this.newCard.cardNumber.length > 4) {
        return this.newCard.cardNumber.length - 4
      }
      return 0
    }
  },
  watch: {
    override_amount(value) {
      if (this.paymentTesting) {
        this.$emit('override-amount', value)
      }
    },
    newCard: {
      handler: function(newvalue, oldvalue) {
        if (this.newCard.cardNumber) {
          this.cardType()
        }
        this.update(newvalue)
      },
      deep: true
    }
  },
  mounted: function() {
    this.$validator.extend('expiry_date', {
      getMessage: function(field, args) {
        return 'Card Expiry Date must be in the future.'
      },
      validate: ExpiryDateValidator
    }, { hasTarget: true })

    this.$validator.attach({
      name: 'expiry_date',
      rules: 'expiry_date'
    })
  },
  methods: {
    update(card) {
      this.$emit('input', card)

      this.$nextTick(_ => {
        this.$validator.validate()
          .then((result) => {
            if (this.newCard.cardValid !== result) {
              this.$emit('cardValid', result, !result)
            }
            if (result) {
              this.$emit('hasErrors', false)
            }
            else {
              this.$emit('hasErrors', true)
            }
          })
      })
    },
    cardType() {
      this.newCard.cardType = Object.keys(this.cards).filter(x => this.cards[x].regex.test(this.newCard.cardNumber)).pop() || null
    },
    errorMessage() {
      if (this.fields.$payment) {
        let fields = Object.keys(this.fields.$payment)

        for (let index = 0; index < fields.length; index++) {
          if (this.fields.$payment[fields[index]].dirty && this.errorBag.first(fields[index], 'payment')) {
            return this.errorBag.first(fields[index], 'payment')
          }
        }
      }
    },
    getErrorState(id) {
      return (this.errorBag.has(id, 'payment') && this.fields.$payment[id].dirty) ? false : null
    }
  }
}
</script>

<style lang="scss">
  @import '~bootstrap/scss/_functions.scss';
  @import '~bootstrap/scss/_variables.scss';
  @import '~bootstrap/scss/_mixins.scss';

  .required {
    label {
      &:after {
        content: ' *';
        color: #ff0000;
      }
    }
  }

  .payment-form {
    .card-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      @include media-breakpoint-down('sm') {
        max-width: 100px;
        margin: 0 auto 1em auto;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
  .error-field {
    text-align: right;
    color: red;
  }
  .card-details-container {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up('md') {
      flex-direction: row;
      justify-content: flex-start;
      align-content: center;
    }
    .card-icon {
      display: flex;
      flex-grow: 1;
      flex-shrink: 1;
      justify-content: center;
      align-items: center;
      max-width: 100px;
      margin: 0 auto 1em auto;
      @include media-breakpoint-up('md') {
        margin: 0 2em 0 0;
      }
      svg {
        width: 100%;
        height: 100%;
      }
    }
    .card-details {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      flex-grow: 1;
      flex-shrink: 0;
      .cardholder {
        font-weight: 600;
      }
      .card-number {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 1em;
        .hidden-digit {
          margin-right: 0.3em;
          .inner-digit {
            width: 0.75em;
            height: 0.75em;
            border-radius: 50% 50%;
            background-color: #747474;
          }
        }
        .visible-digit {
          font-size: 1em;
          font-family: monospace;
          margin-right: 0.3em;
        }
        .spacer {
          width: 0.7em;
          height: 1em;
        }
      }
      .card-expiry {
        color: #747474;
        font-weight: 600;
        display: flex;
      }
    }
  }
</style>
